module.exports = __webpack_public_path__ + "img/doorbell-netatmo.924f5fb5.png";